import * as React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { session } from '../../shared/session';
import { isAuthorized } from '../../shared/auth';
import { ROLE } from '../../config/Role';

interface PrivateRouteProps extends RouteProps {
    // render: (() => ReactComponentElement<any>) | undefined;
    authorizedRoles?: Array<ROLE>;
    path: string;
    invert?: boolean;
    redirectTo?: string;
}

export function ProtectedRoute({
    // render,
    redirectTo = '/login',
    invert,
    authorizedRoles,
    path,
    children,
    ...rest
}: PrivateRouteProps) {
    const temp: boolean =
        authorizedRoles && authorizedRoles.length
            ? isAuthorized(authorizedRoles)
            : session.isAuthenticated();

    const isAuthorizedFlag: boolean = invert ? !temp : temp;

    //@ts-ignore
    // console.log('isAuthorizedFlag', session.isAuthenticated(), isAuthorized(authorizedRoles));

    const renderChild = isAuthorizedFlag ? (
        children
    ) : (
        <Redirect to={redirectTo} />
    );

    return <Route {...rest} path={path} children={renderChild} />;
}
